import React from "react";

export default function Header() {
  return (
    <div className="">
      <h1 className="sub-heading flex items-end tracking-tight font-bold text-center justify-center mb-8">
        About Us
      </h1>

      <div className="h-[2px] bg-bright w-24 mx-auto mb-12" />

      {/* Top Two Paragraphs Section */}
      <div className="flex flex-col gap-8 mb-16 max-w-[900px] mx-auto px-4">
        <span
          className="med-text font-bold text-center text-bright"
          style={{
            lineHeight: 1.2,
          }}
        >
          Avinya means innovation and green is our soul motto!
        </span>
        <p className="sm-text text-center text-justify leading-relaxed opacity-95">
          At Avinya Green Constructions, innovation and sustainability are at
          the core of our mission. We understand that traditional
          builder-delivered properties often fall short of meeting clients'
          unique needs, leading to costly and time-consuming remodels. Our
          comprehensive, eco-friendly construction solutions provide a
          seamless experience from start to finish. From initial concept and
          architecture to statutory approvals, soil testing and structural
          design, we ensure every detail is meticulously handled. Our
          commitment to transparency and excellence guarantees that your dream
          property is realized without the usual stress and setbacks.
        </p>
        <p className="sm-text text-center text-justify leading-relaxed opacity-95">
          Our dedication extends beyond construction. We manage
          post-construction activities, including interiors, renting, leasing,
          security management and marketing, ensuring your property is not
          only built to perfection but also maintained to the highest
          standards. Environmental preservation is embedded in our core
          values and we set benchmarks in sustainability across all our
          projects. At Avinya Green Construction, we strive to make your
          construction journey smooth and rewarding, prioritizing your needs
          and the environment at every step. Trust us to bring your vision to
          life with integrity and unparalleled expertise.
        </p>
      </div>

      {/* Large Centered Image */}
      <div className="flex flex-col items-center justify-center mb-16">
        <img
          src="/assets/images/agc_registered.png"
          alt="AGC Registered"
          className="max-w-[900px] h-auto rounded-2xl shadow-2xl"
        />
      </div>

      {/* ISO Certification Section */}
      <div className="flex flex-col items-center justify-center mb-16 gap-8 max-w-[900px] mx-auto px-4">
        <p className="sm-text text-center leading-relaxed font-medium opacity-95">
          As an <span className="font-bold text-bright">ISO 9001:2015</span> Certified organisation, AGC is committed to maintaining the highest standards of quality, efficiency, innovation and customer satisfaction. Our robust quality management practices ensure consistent project delivery, continuous improvement and reliable engineering and construction solutions that meet international standards and industry best practices.
        </p>
      </div>

      {/* <div className=" mt-10">
        <h1 className=" large-text font-medium md:text-left text-center">
          Certificates / Collaboration
        </h1>
        <div className=" flex flex-wrap content-center justify-center mt-8 gap-4">
          {[...Array(6)].map((_, i) => {
            return (
              <div
                key={i}
                className=" rounded-lg bg-dark text-light sm-text px-4 p-2"
              >
                Entry {i + 1}
              </div>
            );
          })}
        </div>
      </div> */}
    </div>
  );
}
